import Vue from "vue";
import { Component, Prop, Provide, Watch, Inject, } from "vue-property-decorator";
import { cloneDeep, findIndex, forEach, reject } from "lodash";
import template from "./linehaulDetail.vue";
import session from '@shared/session';
import { Checkbox, Upload, MessageBox, Dialog, Message } from 'element-ui';
import errorHandler from '@shared/error-handler';
import NewTrip from '@panelComponents/newTrip/newTrip';
import ControlPanelService from '@services/control-panel/controlPanelService';
import WaittingBtn from '@components/waitting-button/waitting-btn';
import TripTools from '@panelComponents/tripTools/tripTools';
import Draggable from 'vuedraggable';
import FileControl from '@panelComponents/fileControl/fileControl';
import controlPanelService from "@services/control-panel/controlPanelService";
import TmsCarrierAutoComplete from '@panelComponents/tms-carrier-auto-complete/tms-carrier-auto-complete';
import { DatePicker, TimePicker } from 'element-ui';

Vue.use(Dialog);
Vue.use(Checkbox);
Vue.use(Upload);
Vue.use(DatePicker);
Vue.use(TimePicker);
@Component({
    mixins: [template],
    name: 'linehaulDetail',
    components: {
        NewTrip,
        WaittingBtn,
        Draggable,
        FileControl,
        TripTools,
        TmsCarrierAutoComplete
    }
})
export default class LinehaulDetail extends Vue {
    @Prop({ default: false})
    show!: Boolean;

    @Prop({ default: '' })
    linehaulId!: String | Number;

    loadingLinehaul: Boolean = false;
    showLinehaulDetail: Boolean = false;
    linehaulDetail: any = {};
    pickerOptions: any = {};
    terminalList: Array<any> = [];
    disableEdit: Boolean = false;
    loadingOrder: Boolean = false;
    addPro: string = '';
    oldPro: string = '';
    orderDetail: any = {};
    showOrderDetail: Boolean = false;
    loadOrderDetail: Boolean = false;

    @Watch('show')
    initLinehaulDetail() {
        this.showLinehaulDetail = this.show;
        this.$nextTick(() => {
            if (this.showLinehaulDetail) {
                this.getLinehaulDetail();
            }
        });
    }

    getLinehaulDetail() {
        let params: any = {
            lh_id: this.linehaulId
        };
        this.loadingLinehaul = true;
        ControlPanelService.getLinehaulDetail(params).subscribe(
            (res: any) => {
                this.linehaulDetail = res.data;
                this.terminalList = this.linehaulDetail.warehouse;
                this.disableEdit = this.linehaulDetail.fk_tms_dispatch_id ? true : false;
                this.loadingLinehaul = false;
            },
            (err: any) => {
                errorHandler.handle(err);
                this.loadingLinehaul = false;
            }
        );
    }

    async batchPrint() {
        let userID = session.getUserId();
        let checkResult: any = await this.checkLinehaulCarrier();
        if (checkResult) {
            window.open(`${TMS_DOMAIN.replace('write_cp', '')}tms_carrier_bol_v2.php?batch_print=1&lh_id=${this.linehaulId}&id=${userID}&recreate=0&email=0&group=`);
        }
    }

    async Loadsheet() {
        window.open(`${TMS_DOMAIN.replace('write_cp', '')}tms_pdf_lh_sheet.php?lh_id=${this.linehaulId}`);
    }

    checkLinehaulCarrier() {
        let params: any = {
            lh_id: this.linehaulId
        };
        return new Promise((resolve: any, reject: any) => {
            ControlPanelService.checkLinehaulCarrier(params).subscribe(
                (res: any) => {
                    resolve(true);
                },
                (err: any) => {
                    reject(false);
                    errorHandler.handle(err);
                }
            );
        });
    }

    addOrderToLinehaul() {
        this.loadingOrder = true;
        let params: any = {
            lh_id: this.linehaulId,
            pro_number: this.addPro
        };
        ControlPanelService.addLinehaulOrder(params).subscribe(
            (res: any) => {
                if (res.data.status == 1) {
                    this.linehaulDetail.lines.push(res.data.data);
                }
                this.loadingOrder = false;
                this.addPro = '';
            },
            (err: any) => {
                errorHandler.handle(err);
                this.loadingOrder = false;
            }
        );
    }

    updateLinehaul() {
        this.loadingLinehaul = true;
        let params: any = {
            lh_id: this.linehaulId,
            input_lh_m_carrier: this.linehaulDetail.fk_location_id,
            input_lh_m_pro: this.linehaulDetail.tms_lh_pro,
            input_lh_m_date: this.linehaulDetail.tms_lh_delivery_appointment_date,
            input_lh_m_time: this.linehaulDetail.tms_lh_delivery_appointment_time,
            input_lh_m_time_to: this.linehaulDetail.tms_lh_delivery_appointment_time_to,
            input_lh_m_orig: this.linehaulDetail.fk_warehouse1_id,
            input_lh_m_dest: this.linehaulDetail.fk_warehouse2_id,
            UserID: session.getUserId(),
            UserToken: session.getUserToken()
        };
        ControlPanelService.updateLinehaul(params).subscribe(
            (res: any) => {
                this.loadingLinehaul = false;
                Message.success('Update Success.');
            },
            (err: any) => {
                this.loadingLinehaul = false;
                errorHandler.handle(err);
            }
        );
    }

    removeOrderConfirm(orderId: any) {
        MessageBox.confirm('Are you sure to remove this order?', 'Remove Order', {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'warning'
        }).then(() => {
            this.removeOrder(orderId);
        }).catch(() => {});
    }

    removeOrder(orderId: any) {
        this.loadingOrder = true;
        let params: any = {
            line_id: orderId
        };
        ControlPanelService.removeLinehaulOrder(params).subscribe(
            (res: any) => {
                if (res.data.status == 1) {
                    let index = findIndex(this.linehaulDetail.lines, (item: any) => {
                        return item.tms_lh_line_id == orderId;
                    });
                    if (index >= 0) {
                        this.linehaulDetail.lines.splice(index, 1);
                    }
                } else {
                    errorHandler.handle(res.data.error);
                }
                this.loadingOrder = false;
            },
            (err: any) => {
                errorHandler.handle(err);
                this.loadingOrder = false;
            }
        );
    }

    saveOldValue(carrierPro: string) {
        this.oldPro = carrierPro;
    }

    changeCarrierPro(order: any) {
        if (!this.linehaulDetail.fk_location_id) {
            errorHandler.handle('Please select a carrier and update LH before adding betond Pro.');
            order.tms_lh_line_pro = this.oldPro;
            return;
        }
        this.loadingOrder = true;
        let params: any = {
            line_id: order.tms_lh_line_id,
            carrier_pro: order.tms_lh_line_pro
        };
        ControlPanelService.updateOrderCarrierPro(params).subscribe(
            (res: any) => {
                this.loadingOrder = false;
            },
            (err: any) => {
                errorHandler.handle(err);
                this.loadingOrder = false;
            }
        );
    }

    showDetail(orderId: any) {
        this.showOrderDetail = true;
        this.getOrderDetailInfo(orderId);
    }

    getOrderDetailInfo(id: any) {
        this.orderDetail = {};
        this.loadOrderDetail = true;
        controlPanelService.getOrderDeatilById(id).subscribe(
            (res: any) => {
                this.orderDetail = res.data;
                this.loadOrderDetail = false;
            },
            (err: any) => {
                errorHandler.handle(err);
                this.loadOrderDetail = false;
            }
        );
    }

    closeDialog() {
        this.showOrderDetail = false;
    }

    openTmsPage() {
        controlPanelService.goTmsOrderEditPage(this.orderDetail.pu_id).subscribe(
            (res: any) => {
                let head = document.getElementsByTagName('head')[0];
                let script = document.createElement('script');
                let scriptTxt = res.replace('<script>', '').replace('</script>', '');
                script.text = scriptTxt;
                head.appendChild(script);
            },
            (err: any) => {
                errorHandler.handle(err);
            }
        );
    }

    closeLinehaulDetail() {
        this.addPro = '';
        this.$emit('closeLinehaul', false);
    }
}